import {
  deleteSifarishData,
  getReportedSifarish,
  getUserSifarish,
  undoDeletedSifarish,
} from "_services";
import { ButtonHeading, CommonModal } from "components";
import BootstrapTable from "components/BootstrapTable";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import MastersFilterModal from "modals/MastersFilterModal";
import { AiOutlineEye } from "react-icons/ai";
import { Images } from "constants";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { utils } from "helper";
import moment from "moment";
import useDocumentTitle from "hooks/useDocumentTitle";
import { getUserList } from "_services/userService";
import { AddSifarishModal } from "modals";
import { MdRestore } from "react-icons/md";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const DeletedSifarish = () => {
  useDocumentTitle("Sifarish | MySifarish");
  const [showFilterModal, setShowFilterModal] = useState(false);
  const getMasterDataList = JSON.parse(localStorage.getItem("masterData"));
  const getUserData = JSON?.parse(localStorage?.getItem("userData"));
  const [sifarishData, setSifarishData] = useState();
  const [isDelete, setIsDelete] = useState(false);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [sifarishToEdit, setSifarishToEdit] = useState(null);
  const itemsPerPage = 10;
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [exportLoad, setExportLoad] = useState(false);

  const debounceRef = useRef(null);

  const initialFilter = {
    userId: "",
    page: 1,
    limit: 10,
    categoryIds: "",
    subCategoryId: "",
    birdId: "",
    startDate: null,
    endDate: null,
    keyword: "",
    // deleteStatus: 2,
  };

  const [searchParams, setSearchParams] = useSearchParams();

  const [filter, setFilter] = useState({
    ...initialFilter,
    userId: searchParams.get("userId") || "",
    page: Number(searchParams.get("page")) || 1,
    limit: Number(searchParams.get("limit")) || 10,
    categoryIds: searchParams.get("categoryIds") || "",
    subCategoryId: searchParams.get("subCategoryId") || "",
    birdId: searchParams.get("birdId") || "",
    startDate: searchParams.get("startDate")
      ? moment(searchParams.get("startDate"))
      : "",
    endDate: searchParams.get("endDate")
      ? moment(searchParams.get("endDate"))
      : "",
    keyword: searchParams.get("keyword") || "",
  });

  const [selectedRange, setSelectedRange] = useState({
    startDate: filter.startDate,
    endDate: filter.endDate,
  });

  useEffect(() => {
    const params = {};

    Object.entries(filter).forEach(([key, value]) => {
      if (
        value !== "" &&
        value !== null &&
        value !== undefined &&
        !(moment.isMoment(value) && !value.isValid())
      ) {
        params[key] = moment.isMoment(value)
          ? value.format("YYYY-MM-DD")
          : value;
      }
    });

    setSearchParams(params);
  }, [filter, setSearchParams]);

  const handleReset = () => {
    setFilter(initialFilter);
    setSearchParams({});
    setSelectedRange({ startDate: null, endDate: null });
  };

  const hasActiveFilters = Object.keys(initialFilter).some((key) => {
    if (key === "page" || key === "limit") return false;

    const currentValue = filter[key];
    const initialValue = initialFilter[key];

    const normalize = (val) =>
      val === "" || val === null || val === undefined ? null : val;

    const curr = normalize(currentValue);
    const init = normalize(initialValue);

    if (moment.isMoment(curr)) {
      return (
        curr.isValid() && (!moment.isMoment(init) || !curr.isSame(init, "day"))
      );
    }

    return curr !== init;
  });

  useEffect(() => {
    // const locationData = location?.state;

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      // if (locationData) {
      //   fetchUserSifarish(locationData);
      // } else {
      // }
      fetchUserSifarish();
    }, 500);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [filter]);

  const handleDelete = (item) => {
    setIsDelete(item);
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, page: page }));
  };

  const renderPagination = () => {
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    const currentPage = filter.page;
    let pages = [];
    const createPageItem = (i) => (
      <li key={i} className={`page-item ${i === currentPage ? "active" : ""}`}>
        <a className="page-link _avPointer" onClick={() => handlePageChange(i)}>
          {i}
        </a>
      </li>
    );

    const rangeStart = Math.max(2, currentPage - 2);
    const rangeEnd = Math.min(totalPages - 1, currentPage + 2);

    pages.push(createPageItem(1));

    if (rangeStart > 2) {
      pages.push(
        <li key="dots-before" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    for (let i = rangeStart; i <= rangeEnd; i++) {
      pages.push(createPageItem(i));
    }

    if (rangeEnd < totalPages - 1) {
      pages.push(
        <li key="dots-after" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    if (totalPages > 1) {
      pages.push(createPageItem(totalPages));
    }

    return (
      <ul className="pagination ">
        <li className={`page-item ${filter?.page === 1 ? "disabled" : ""}`}>
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter?.page - 1)}
          >
            <IoChevronBack />
          </a>
        </li>
        {pages}
        <li
          className={`page-item ${
            filter?.page === totalPages ? "disabled" : ""
          }`}
        >
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter?.page + 1)}
          >
            <IoChevronForward />
          </a>
        </li>
      </ul>
    );
  };

  const fetchUserSifarish = async (data) => {
    setLoading(true);
    try {
      const payload = {
        ...filter,
        userId: getUserData?._id,
        createdByUserId: "",
        categoryIds: filter?.categoryIds ? [filter.categoryIds] : [],
        subCategoryId: filter?.subCategoryId ? [filter?.subCategoryId] : [],
        birdId: filter?.birdId,
        startDate: selectedRange.startDate
          ? moment(selectedRange.startDate).format("YYYY-MM-DD")
          : "",
        endDate: selectedRange.endDate
          ? moment(selectedRange.endDate).format("YYYY-MM-DD")
          : "",
        deleteStatus: 2,
        activeStatus: 2,
      };

      const res = await getReportedSifarish(payload);
      if (res) {
        setTotalCount(res?.data?.totalRecords);
        setSifarishData(res?.data);
      } else {
        toast.error(res?.responseMessage);
      }
      setLoading(false);
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setLoading(false);
    }
  };

  const columns = [
    { header: "", accessor: "serial" },
    { header: "User", accessor: "userName" },
    { header: "Bird", accessor: "birdId" },
    { header: "Title ", accessor: "title" },
    { header: "Category ", accessor: "category" },
    { header: "Subcategory", accessor: "subCategories" },
    { header: "Sifarish Image", accessor: "sifarishImage" },
    { header: "City", accessor: "city" },
    { header: "State", accessor: "state" },
    { header: "Country", accessor: "country" },
    { header: "Forward Count", accessor: "forward_count" },
    { header: "Saved Count", accessor: "saved_count" },
    { header: "QR Scanned", accessor: "qr_scanned" },
    { header: "Reported Count", accessor: "reported_count" },
  ];

  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      serial: (
        <React.Fragment>
          <div className="signDropdown">
            <button className="dropbtn11">
              <BsThreeDotsVertical />
            </button>
            <div className="dropdownContent">
              <Link
                to={`/sifarish/getSifarishes?userId=${getUserData?._id}&sifarishId=${item?._id}`}
                state={{
                  listData: sifarishData?.sifarishes,
                  currentIndexx: i,
                }}
                className="_avPointer"
                style={{ textDecoration: "none" }}
              >
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <AiOutlineEye />
                  </span>
                  &nbsp; View
                </span>
              </Link>

              <div className="_avPointer" onClick={() => handleDelete(item)}>
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <MdRestore />
                  </span>
                  Restore
                </span>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
      userName: (
        <React.Fragment>
          <img
            src={item?.createdByUserId?.userProfileImageUrl || Images.USERLIMG}
            alt="user Img"
            style={{ borderRadius: "50%" }}
            width={30}
            height={30}
          />
          <span>{`${item?.createdByUserId?.firstName || "-"} ${
            item?.createdByUserId?.lastName || "-"
          }`}</span>
        </React.Fragment>
      ),

      birdId: <React.Fragment>{item?.birdId?.title || "-"}</React.Fragment>,

      title: (
        <React.Fragment>
          <div className="__anvDots" title={item?.title}>
            {item?.title || "-"}
          </div>
        </React.Fragment>
      ),

      category: (
        <React.Fragment>{item?.categoryId?.title || "-"}</React.Fragment>
      ),

      subCategories: (
        <React.Fragment>
          {item?.categoryId?.subCategories?.length > 0
            ? item.categoryId.subCategories
                .filter((sub) => sub._id === item.subCategoryId)
                .map((sub) => <span key={sub._id}>{sub.title}</span>)
            : "-"}
        </React.Fragment>
      ),

      sifarishImage: (
        <React.Fragment>
          {item.mediaUrls.length > 0 ? (
            <div className="__imgMedia">
              <img
                src={
                  item.mediaUrls[0]?.url ||
                  "https://via.placeholder.com/400x300"
                }
                alt={`Sifarish_${item.mediaUrls.length}`}
                width={40}
                height={30}
                className="_slidImg"
              />
            </div>
          ) : (
            <p>No Image Available</p>
          )}
        </React.Fragment>
      ),

      city: <React.Fragment>{item?.address?.city || "-"}</React.Fragment>,

      state: <React.Fragment>{item?.address?.state || "-"}</React.Fragment>,

      country: <React.Fragment>{item?.address?.country || "-"}</React.Fragment>,

      forward_count: (
        <React.Fragment>{item?.forwardedCount || 0}</React.Fragment>
      ),
      saved_count: <React.Fragment>{item?.saveCount || 0}</React.Fragment>,
      qr_scanned: <React.Fragment>{item?.qrScanCount || 0}</React.Fragment>,
      reported_count: (
        <React.Fragment>{item?.reported?.length || 0}</React.Fragment>
      ),
    }));
  };

  const submitDeleteUser = async () => {
    const payload = {
      userId: getUserData?._id,
      sifarishId: isDelete?._id,
    };
    try {
      const res = await undoDeletedSifarish(payload);
      if (!!res) {
        fetchUserSifarish(getUserData?._id);
        setIsDelete(false);
        toast.success(res?.message);
      } else {
        toast.error("Error !! ");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error !! ");
      setIsDelete(false);
    }
  };

  let propsDelete = {
    isOpen: isDelete,
    closeModal: () => setIsDelete(false),
    modalMainClass: "confirmModal_new",
    footerPart: true,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancelButtonTitle: "Close",
    onSubmit: submitDeleteUser,
    // isLoadding: loading,
  };

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
    setFilter((s) => ({
      ...s,
      page: 1,
      startDate: newRange.startDate,
      endDate: newRange.endDate,
    }));
  };

  const AddSifarisheModal = {
    isOpen,
    closeModal: () => setIsOpen(false),
    modalMainClass: "_dashCommon_Modal _lgModal",
    modalTitle: sifarishToEdit ? "Edit Sifarish" : "Add Sifarish",
    footerPart: true,
    submitTitle: sifarishToEdit ? "Update Sifarish" : "Add Sifarish",
    setFilter: { setFilter },
    filter: { filter },
    userData: getUserData,
    onSuccess: () => fetchUserSifarish(getUserData._id),
    sifarishToEdit: sifarishToEdit,
    // disable:{disable}
  };

  const exportToCSV = async () => {
    const loadingToast = toast.loading(
      "Please wait, Deleted Sifarish data is getting exported..."
    );
    setExportLoad(true);

    try {
      const payload = {
        ...filter,
        userId: getUserData?._id,
        createdByUserId: "",
        categoryIds: filter?.categoryIds ? [filter.categoryIds] : [],
        subCategoryId: filter?.subCategoryId ? [filter?.subCategoryId] : [],
        birdId: filter?.birdId,
        startDate: selectedRange.startDate
          ? moment(selectedRange.startDate).format("YYYY-MM-DD")
          : "",
        endDate: selectedRange.endDate
          ? moment(selectedRange.endDate).format("YYYY-MM-DD")
          : "",
        deleteStatus: 2,
        activeStatus: 2,
        page: 1,
        limit: 1000,
      };

      const firstRes = await getReportedSifarish(payload);

      if (
        !firstRes ||
        !firstRes.data?.sifarishes ||
        firstRes.data.sifarishes.length === 0
      ) {
        toast.dismiss(loadingToast);
        toast.error("No data to export!");
        setExportLoad(false);
        return;
      }

      const totalPages = firstRes.data.totalPages || 1;
      const totalRecords =
        firstRes.data.totalRecords || firstRes.data.sifarishes.length;

      toast.dismiss(loadingToast);
      toast.success(
        `Exporting ${totalRecords} records in ${totalPages} chunks...`
      );

      let allData = [...firstRes.data.sifarishes];

      for (let page = 2; page <= totalPages; page++) {
        let success = false;
        let retries = 3;

        while (!success && retries > 0) {
          try {
            const res = await getReportedSifarish({ ...payload, page });
            if (res?.data?.sifarishes?.length) {
              allData = [...allData, ...res.data.sifarishes];
            }
            success = true;
          } catch (err) {
            console.warn(`Retrying page ${page}... (${3 - retries + 1})`);
            retries--;
            await new Promise((r) => setTimeout(r, 1000));
          }
        }
      }

      const chunkSize = 10000;
      const numFiles = Math.ceil(allData.length / chunkSize);

      for (let i = 0; i < numFiles; i++) {
        const chunk = allData.slice(i * chunkSize, (i + 1) * chunkSize);

        const filterSummary = [
          {
            Key: "Category",
            Value:
              getMasterDataList?.categories?.find(
                (opt) => opt._id === filter?.categoryIds
              )?.title || "All",
          },
          {
            Key: "Sub Category",
            Value:
              getMasterDataList?.categories
                ?.flatMap((bird) => bird?.subCategories || [])
                ?.find((sub) => sub?._id === filter?.subCategoryId)?.title ||
              "All",
          },
          {
            Key: "Bird",
            Value:
              getMasterDataList?.birds?.find(
                (opt) => opt._id === filter?.birdId
              )?.title || "All",
          },
          { Key: "Searched Word", Value: filter?.keyword || "-" },
          {
            Key: "Date Range",
            Value: selectedRange?.startDate
              ? `${moment(selectedRange.startDate).format(
                  "DD-MM-YYYY"
                )} - ${moment(selectedRange.endDate).format("DD-MM-YYYY")}`
              : "All Time",
          },
        ];

        const formattedData = chunk.map((item, index) => ({
          "Serial No": i * chunkSize + index + 1,
          User: `${item?.createdByUserId?.firstName || "-"} ${
            item?.createdByUserId?.lastName || "-"
          }`,
          Bird: item?.birdId?.title || "-",
          Title: item?.title || "-",
          Category: item?.categoryId?.title || "-",
          SubCategories:
            item?.categoryId?.subCategories?.length > 0
              ? item.categoryId.subCategories.find(
                  (sub) => sub._id === item.subCategoryId
                )?.title || "-"
              : "No Subcategories Available",
          "Sifarish Image":
            item.mediaUrls?.length > 0
              ? item.mediaUrls[0]?.url
              : "No Image Available",
          City: item?.address?.city || "-",
          State: item?.address?.state || "-",
          Country: item?.address?.country || "-",
          "Forward Count": item?.forwardedCount || "-",
          "Saved Count": item?.saveCount || "-",
          "QR Scanned": item?.qrScanCount || 0,
          "Reported Count": item?.reported?.length || "-",
          "User Saved Status":
          item?.createdByUserSavedStatus?.status === 0
            ? "Not Saved"
            : item?.createdByUserSavedStatus?.status === 1
            ? "Recommended"
            : item?.createdByUserSavedStatus?.status === 2
            ? "Not Recommended"
            : "-",
        }));

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet([], { skipHeader: true });

        const keyColumn = "C";
        const valueColumn = "E";

        ws[`${keyColumn}1`] = { t: "s", v: "Filter Type" };
        ws[`${valueColumn}1`] = { t: "s", v: "Filter Value" };

        filterSummary.forEach((item, index) => {
          const rowNum = index + 3;
          ws[`${keyColumn}${rowNum}`] = { t: "s", v: item.Key };
          ws[`${valueColumn}${rowNum}`] = { t: "s", v: item.Value };
        });

        XLSX.utils.sheet_add_json(ws, formattedData, {
          origin: "A9",
          skipHeader: false,
        });

        const dataOnly = formattedData.map((r) => r);
        XLSX.utils.sheet_add_json(ws, dataOnly, {
          origin: "A10",
          skipHeader: true,
        });

        ws["!cols"] = [
          { wch: 8 },
          { wch: 25 },
          { wch: 15 },
          { wch: 40 },
          { wch: 25 },
          { wch: 30 },
          { wch: 40 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 20 },
          { wch: 15 },
        ];

        XLSX.utils.book_append_sheet(wb, ws, `Deleted_Sifarish_${i + 1}`);

        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        const epochTime = Date.now();
        saveAs(blob, `Deleted_Sifarish_List_Part_${i + 1}_${epochTime}.xlsx`);
      }

      toast.success("All Deleted Sifarish data exported successfully!");
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error(error?.message || "Something went wrong during export.");
    } finally {
      setExportLoad(false);
    }
  };

  return (
    <>
      <ButtonHeading
        title={"Deleted Sifarishes"}
        Export={true}
        ExportSubmit={exportToCSV}
        exportLoad={exportLoad}
        showDateRange={true}
        selectedRange={selectedRange}
        handleApply={handleApply}
        showSearchFilter={{ filterOption: false, filterCount: true }}
        setFilter={setFilter}
        filter={filter}
        onClickFilterModal={(e) => setShowFilterModal(false)}
        isShow={{
          category: true,
          subcategory: true,
          birds: true,
          keyword: true,
          // search: true,
        }}
        handleReset={() => handleReset()}
        showResetFilter={hasActiveFilters}
      />

      <div className="_tabWith_outTab">
        <BootstrapTable
          columns={columns}
          data={rowListData(
            sifarishData?.sifarishes?.length > 0 ? sifarishData?.sifarishes : []
          )}
          //   data={rowListData(
          //     Array.isArray(sifarishData?.sifarishes)
          //       ? sifarishData
          //       : { sifarishes: [] }
          //   )}
          colSpan={14}
          isLoading={loading}
        />

        <div className="paginationFt_avt">{renderPagination()}</div>
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${
          showFilterModal ? "show" : ""
        }`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? "visible" : "hidden" }}
      >
        {showFilterModal && (
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
            isShow={{
              dateRange: true,
              allBranch: true,
              consignor: true,
            }}
            name="plan"
          />
        )}
      </div>
      <div className={showFilterModal ? "offBack_drop" : ""}></div>

      {isDelete?._id && (
        <CommonModal {...propsDelete}>
          <p className="p-3">
            {" "}
            Are you sure you want to Restore this Sifarish {isDelete?.title} ?
          </p>
        </CommonModal>
      )}

      {isOpen && (
        <AddSifarishModal
          {...AddSifarisheModal}
          // userId={getUserData?._id}
          // userIdToUpdate={userToEdit._id}
          // userData={userToEdit}
          // props={EditUserModal}
        />
      )}
    </>
  );
};

export default DeletedSifarish;
